import globalAxios from "../GlobalAxios";

const listApi = async (params) => {
  const res = await globalAxios.get("/api/asset/list", {params});
  if(res){
    return res.data;
  }
};

const allListApi = async (params) => {
  const res = await globalAxios.get("/api/asset/all", {params});
  if(res){
    return res.data;
  }
};

const groupApi = async () => {
  const res = await globalAxios.get("/api/asset/group-list");
  if(res){
    return res.data.list;
  }
};

const inGroupInfoApi = async (asset_id) => {
  const res = await globalAxios.get("/api/asset/asset-inGroup", {params: {asset_id}});
  if(res){
    return res.data.list;
  }
};

const inGroupApi = async (params) => {
  const res = await globalAxios.get("/api/asset/list-inGroup", {params});
  if(res){
    return res.data;
  }
};

const statusApi = async (params) => {
  const res = await globalAxios.get("/api/asset/list-status", {params});
  if(res){
    return res.data.list;
  }
};

const assetDetailApi = async (asset_id) => {
  const res = await globalAxios.get("/api/asset/detail", {params: {asset_id}});
  if(res){
    return res.data;
  }
};

const addGroupApi = async (group_name) => {
  const res = await globalAxios.post("/api/asset/add-group", {group_name});
  if(res){
    return res.data;
  }
};

const addInGroupApi = async (params) => {
  const res = await globalAxios.post("/api/asset/add-inGroup", {params});
  if(res){
    return res.data;
  }
};

const addInGroupSingleApi = async (params) => {
  const res = await globalAxios.post("/api/asset/add-inGroup-single", {params});
  if(res){
    return res.data;
  }
};

const updateGroupApi = async (params) => {
  const res = await globalAxios.post("/api/asset/update-group", {params});
  if(res){
    return res.data;
  }
};

const deleteGroupApi = async (group_id) => {
  const res = await globalAxios.post("/api/asset/delete-group", {group_id});
  if(res){
    return res.data;
  }
};

const updateInfoApi = async (params) => {
  const res = await globalAxios.post("/api/asset/update", {params});
  if(res){
    return res.data;
  }
};

const addTagApi = async (params) => {
  const res = await globalAxios.post("/api/asset/add-tag", {params});
  if(res){
    return res.data;
  }
};

const deleteTagApi = async (params) => {
  const res = await globalAxios.post("/api/asset/delete-tag", {params});
  if(res){
    return res.data;
  }
};

const deleteAllApi = async (params) => {
  const res = await globalAxios.post("/api/asset/delete", {params});
  if(res){
    return res.data;
  }
};

const reqEncodeApi = async (params) => {
  const res = await globalAxios.post("/api/asset/req-encode", {params});
  if(res){
    return res.data;
  }
};

const distributionApi = async (params) => {
  const res = await globalAxios.post("/api/asset/distribution", {params});
  if(res){
    return res.data;
  }
};

const uploadTnApi = async (formData) => {
  const res = await globalAxios.post("/api/asset/upload-thumbnail", formData);
  if(res){
    return res.data;
  }
};

const deleteTnApi = async (params) => {
  const res = await globalAxios.post("/api/asset/delete-thumbnail", {params});
  if(res){
    return res.data;
  }
};

const delSingleApi = async (params) => {
  const res = await globalAxios.post("/api/asset/delete-single", {params});
  if(res){
    return res.data;
  }
};

const testApi = async () => {
  const res = await globalAxios.get("/api/a/test");
  if(res){
    return res.data;
  }
};

const getAllList = async () => {
  const res = await globalAxios.get("/api/asset/all-list");
  if(res){
    return res.data;
  }
};

const reqCheck = async (params) => {
  const res = await globalAxios.get("/api/asset/check-encoding", {params: params});
  if(res){
    return res.data;
  }
};

const posterApi = async (params) => {
  const res = await globalAxios.get("/api/asset/poster", {params: params});
  if(res){
    return res.data;
  }
};

const getTranscript = async (assetId) => {
  const res = await globalAxios.get(`/api/asset/${assetId}/transcript`);
  return res.data;
};

const getTranscriptByAid = async (aid) => {
  const res = await globalAxios.get(`/api/asset/transcript/aid/${aid}`);
  return res.data;
};

const getTranscriptByUuid = async (uuid) => {
  const res = await globalAxios.get(`/api/asset/transcript/by-uuid/${uuid}`);
  return res.data;
};

const requestTranscript = async (assetId) => {
  const res = await globalAxios.post(`/api/asset/${assetId}/transcript/request`);
  return res.data;
};

const updateTranscript = async (assetId, payload) => {
  const res = await globalAxios.put(`/api/asset/${assetId}/transcript`, payload);
  return res.data;
};

const deleteTranscript = async (assetId) => {
  const res = await globalAxios.delete(`/api/asset/${assetId}/transcript`);
  return res.data;
};

const downloadTranscript = async (assetId) => {
  const res = await globalAxios.get(`/api/asset/${assetId}/transcript/download`, {
    responseType: 'blob'
  });
  return res.data;
};

// const encApi = async (params) => {
//   const res = await globalAxios.get("/api/enc", {params});
//   if(res){
//     return res.data;
//   }
// };


export default {
    listApi,
    allListApi,
    groupApi,
    inGroupInfoApi,
    inGroupApi,
    statusApi,
    assetDetailApi,
    addGroupApi,
    addInGroupApi,
    updateGroupApi,
    deleteGroupApi,
    updateInfoApi,
    addTagApi,
    deleteTagApi,
    deleteAllApi,
    reqEncodeApi,
    distributionApi,
    updateTranscript,
    uploadTnApi,
    deleteTnApi,
    delSingleApi,
    addInGroupSingleApi,
    testApi,
    getAllList,
    reqCheck,
    posterApi,
    getTranscript,
    getTranscriptByAid,
    getTranscriptByUuid,
    requestTranscript,
    deleteTranscript,
    downloadTranscript,
    // encApi,
};
